import { useEffect, useState } from 'react';

/** 본문과 자식의 크기 변화를 관찰해 고정 작업 영역에 필요한 스크롤 경계를 알려 줍니다. */
export function useDialogContentOverflow(enabled = true) {
  const [content, setContent] = useState<HTMLDivElement | null>(null);
  const [overflowing, setOverflowing] = useState(false);

  useEffect(() => {
    if (!enabled || !content) {
      setOverflowing(false);
      return;
    }

    const measure = () => setOverflowing(content.scrollHeight > content.clientHeight);
    const resizeObserver = new ResizeObserver(measure);
    const observeContent = () => {
      resizeObserver.disconnect();
      resizeObserver.observe(content);
      // 별도 wrapper를 만들지 않아 fill 본문과 자식의 기존 flex 관계를 보존합니다.
      for (const child of content.children) resizeObserver.observe(child);
      measure();
    };
    const mutationObserver = new MutationObserver(observeContent);
    mutationObserver.observe(content, { childList: true, subtree: true, characterData: true });
    observeContent();

    return () => {
      resizeObserver.disconnect();
      mutationObserver.disconnect();
    };
  }, [content, enabled]);

  return { contentRef: setContent, overflowing: enabled && overflowing };
}
